export const CONTENT_MAX_W = { base: '100%', xl: '1760px', '2xl': '1920px' };

export const SIDEBAR_COL_W = { base: 0, md: 64, lg: 72 };

export const SIDEBAR_EXP_W = { base: 0, md: 220, lg: 260, xl: 280 };

export const HEADER_HEIGHT = { base: 56, md: 64 };
